<div class="main-db gap-top">
  <div class="container-fluid mt-2">

    <div class="row">      
      <div class="col-12 col-sm-6">
        <h1>{{title}}</h1>
      </div>
      
      <!-- <div class="col-12 col-sm-6 mb-2">
        <button class="btn btn-sm btn-success float-right mr-1" (click)="exportPassportCSV()"><i class="fas fa-cloud-download-alt mr-1"></i>
          Export Passport CSV</button>
        <button class="btn btn-sm btn-success float-right mr-1" (click)="exportPaymentCSV()"><i class="fas fa-file-csv mr-1"></i>
          Export Payment CSV</button>
        <button class="btn btn-sm btn-success float-right mr-1" (click)="exportEmployeesCSV()"><i class="fas fa-cloud-download-alt mr-1"></i>
          Export CSV</button>
      </div> -->
    </div>




    <div class="main-content">
      <div class="container-fluid">

        <div *ngIf="userRole == 'ROLE_SUPER_ADMIN'" class="card">
          <h5 class="card-header h5">Clients - {{allOrgsData.length}}</h5>
          <div class="card-body row">
            <div class="col-lg-3 col-md-6 col-sm-6" *ngFor="let org of allOrgsData | slice:0:4;">
              <div class="card">
                <div class="card-header">
                  <div class="row">

                    <div class="col-2 mr-1">
                      <img *ngIf="org.logo; else defaultlogo" [src]="getLogo(org.logo)" alt="Olios" class="brand-image" style="height: 30px; width: 30px;">
                      <ng-template #defaultlogo>
                        <img src="assets/images/logo.png" alt="Olios" class="brand-image" style="height: 30px; width: 30px;">
                      </ng-template>
                    </div>

                    <div class="col-9 mt-2">
                      <h3 class="card-title">{{org.name}}</h3>
                    </div>

                    <div class="col-12 mt-1">
                      <p class="mx-auto my-auto">
                        <i class="fa fa-envelope mr-1"></i>
                        {{org.emailAddress}}
                      </p>                              
                    </div>

                  </div>
                </div>
                <div class="card-footer">
                  <div class="row">
                    <div class="col-8">
                      <a class="text-white" (click)="viewOrganizationDetails(org.id)"><i class="fa fa-eye mr-1 text-warning"></i>View Details</a>
                    </div>
                    <div class="col-4 text-right">
                      <mat-slide-toggle
                        [checked] = "checkedToggle"
                        [disabled] = "disabledToggle">
                      </mat-slide-toggle>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 text-right">
                <a href="">View More</a>
            </div>
          </div>
        </div>







        <!-- <div class="card">
          <h5 class="card-header h5">Yearly Statistics</h5>
          <div class="card-body row">

            <div class="card col-6">
              <div class="card-header">
                <div style="display: block">
                  <canvas baseChart id="totalScansChart"
                          [datasets]="barChartDataScans"
                          [labels]="barChartLabelsScans"
                          [options]="myoption"
                          [legend]="barChartLegend"
                          [chartType]="barChartType"
                          [colors]="barChartColorsScan">
                  </canvas>
                </div>
              </div>
            </div>

            <div class="card col-6">
              <div class="card-header">
                <div style="display: block">
                  <canvas baseChart id="totalViolationsChart"
                          [datasets]="barChartDataViolations"
                          [labels]="barChartLabelsViolations"
                          [options]="myoption"
                          [legend]="barChartLegend"
                          [chartType]="barChartType"
                          [colors]="barChartColorsViolation">
                  </canvas>
                </div>
              </div>
            </div>

          </div>
      </div> -->
      





      <div class="card">
        <h5 class="card-header h5">Yearly Statistics</h5>
        <div class="card-body row">

          <div class="card col-12">
            <div class="card-header">
              <div style="display: block">
                <canvas  id="lineChartYearly" >{{ chart }}</canvas>
              </div>
            </div>
          </div>

        </div>
    </div>





        <div class="card">
          <h5 class="card-header h5">Dynamic Statistics</h5>
          <div class="card-body row">

            <div class="card col-6">
              <div class="card-header">
                <div class="h5 mb-3 text-center">
                  {{chartNameMonthly}}
                </div>
                
                <div class="form-group p-1 col-4 float-left">
                  <!-- <label>Select Date Range</label> -->
                  <input readonly type="text" matInput placeholder="Select Date Range"
                    class="form-control form-control-sm  input-custom pl-2 mt-0"
                    ngxDaterangepickerMd
                    [locale]="{format: 'YYYY-MM-DD'}"
                    [(ngModel)]="selectedDateMonthly"
                    startKey="start"
                    endKey="end"
                    [showCustomRangeLabel]="true"
                    [alwaysShowCalendars]="true"
                    [linkedCalendars]="true"
                    name="daterange"/>
                </div>
              
                <div *ngIf="userRole == 'ROLE_SUPER_ADMIN'" class="col-4 float-left form-group p-1">
                  <select class="form-control form-control-sm input-custom" (change)="selectOrgMonthly($event.target.value)">
                    <option value="" >Select Organization</option>
                    <option *ngFor="let orgObject of allOrgsData" [value]="orgObject.id">{{orgObject.name}}</option>
                  </select>
                </div>
              
                <div class="form-group p-1 col-1 float-left">
                  <button class="btn btn-sm btn-success w-100" type="button" (click)="searchOrgDataMonthly()"><i class="fas fa-search"></i></button>
                </div>
              

                <div class="form-group p-1 col-2 float-right">
                  <a type="button" class="mr-3 mt-2 float-right" (click)="downloadChartImageForAll($event, selectedOrgStatsDataMonthly, 1, chartNameMonthly)">
                    <i class="fas fa-image mr-1" aria-hidden="true" matTooltip="Export Chart PNG"></i>
                  </a>
                  <a type="button" class="mr-3 mt-2 float-right" (click)="excelSheetDownloadForAll(selectedOrgStatsDataMonthly, chartNameMonthly)">
                    <i class="fa fa-file mr-1" aria-hidden="true" matTooltip="Export Shift Report"></i>
                  </a>
                </div>

                <!-- <div class="form-group p-1 col-2 float-right">
                  <a type="button" class="mr-3 mt-2 float-right" (click)="downloadChartImageMonthly($event)">
                    <i class="fas fa-image mr-1" aria-hidden="true" matTooltip="Export Chart PNG"></i>
                  </a>
                  <a type="button" class="mr-3 mt-2 float-right" (click)="excelSheetDownloadMonthly()">
                    <i class="fa fa-file mr-1" aria-hidden="true" matTooltip="Export Shift Report"></i>
                  </a>
                </div> -->
              
              
                <div class="container-fluid">
                  <div>
                    <div style="display: block">
                      <canvas baseChart id="monthlyChart"
                              [datasets]="barChartDataMonthly"
                              [labels]="barChartLabelsMonthly"
                              [options]="myoption"
                              [legend]="barChartLegend"
                              [chartType]="barChartType">
                      </canvas>
                    </div>
                  </div>
                </div>
              </div>
            </div>







            <div class="card col-6">
              <div class="card-header">
                <div class="h5 mb-3 text-center">
                  {{chartNameDaily}}
                </div>

                <div class="form-group p-1 col-4 float-left">
                  <!-- <label>Select Date Range</label> -->
                  <input readonly type="text" matInput placeholder="Select Date Range"
                    class="form-control form-control-sm  input-custom pl-2 mt-0"
                    ngxDaterangepickerMd
                    [locale]="{format: 'YYYY-MM-DD'}"
                    [(ngModel)]="selectedDateDaily"
                    startKey="start"
                    endKey="end"
                    [showCustomRangeLabel]="true"
                    [alwaysShowCalendars]="true"
                    [linkedCalendars]="true"
                    name="daterange"/>
                </div>
              
                <div *ngIf="userRole == 'ROLE_SUPER_ADMIN'" class="col-4 float-left form-group p-1">
                  <select class="form-control form-control-sm input-custom" (change)="selectOrgDaily($event.target.value)">
                    <option value="" >Select Organization</option>
                    <option *ngFor="let orgObject of allOrgsData" [value]="orgObject.id">{{orgObject.name}}</option>
                  </select>
                </div>
              
                <div class="form-group p-1 col-1 float-left">
                  <button class="btn btn-sm btn-success w-100" type="button" (click)="searchOrgDataDaily()"><i class="fas fa-search"></i></button>
                </div>
              
                <div class="form-group p-1 col-2 float-right">
                  <a type="button" class="mr-3 mt-2 float-right" (click)="downloadChartImageForAll($event, selectedOrgStatsDataDaily, 2, chartNameDaily)">
                    <i class="fas fa-image mr-1" aria-hidden="true" matTooltip="Export Chart PNG"></i>
                  </a>
                  <a type="button" class="mr-3 mt-2 float-right" (click)="excelSheetDownloadForAll(selectedOrgStatsDataDaily, chartNameDaily)">
                    <i class="fa fa-file mr-1" aria-hidden="true" matTooltip="Export Shift Report"></i>
                  </a>
                </div>
                <!-- <div class="form-group p-1 col-2 float-right">
                  <a type="button" class="mr-3 mt-2 float-right" (click)="downloadChartImageDaily($event)">
                    <i class="fas fa-image mr-1" aria-hidden="true" matTooltip="Export Chart PNG"></i>
                  </a>
                  <a type="button" class="mr-3 mt-2 float-right" (click)="excelSheetDownloadDaily()">
                    <i class="fa fa-file mr-1" aria-hidden="true" matTooltip="Export Shift Report"></i>
                  </a>
                </div> -->
              
              
                <div class="container-fluid">
                  <div>
                    <div style="display: block">
                      <canvas baseChart id="dailyChart"
                              [datasets]="barChartDataDaily"
                              [labels]="barChartLabelsDaily"
                              [options]="myoption"
                              [legend]="barChartLegend"
                              [chartType]="barChartType">
                      </canvas>
                    </div>
                  </div>
                </div>
              </div>
            </div>








            <div class="card col-6 ">
              <div class="card-header">
                <div class="h5 mb-3 text-center"> 
                  {{chartNameAllGeofence}} 
                </div>

                <div>
                  <div class="form-group p-1 col-4 float-left">
                    <!-- <label>Select Date Range</label> -->
                    <input readonly type="text" matInput placeholder="Select Date Range"
                      class="form-control form-control-sm  input-custom pl-2 mt-0"
                      ngxDaterangepickerMd
                      [locale]="{format: 'YYYY-MM-DD'}"
                      [(ngModel)]="selectedDateAllGeofence"
                      startKey="start"
                      endKey="end"
                      [showCustomRangeLabel]="true"
                      [alwaysShowCalendars]="true"
                      [linkedCalendars]="true"
                      name="daterange"/>
                  </div>
                
                  <div *ngIf="userRole == 'ROLE_SUPER_ADMIN'" class="col-4 float-left form-group p-1">
                    <select class="form-control form-control-sm input-custom" (change)="selectOrgAllGeofence($event.target.value)">
                      <option value="" >Select Organization</option>
                      <option *ngFor="let orgObject of allOrgsData" [value]="orgObject.id">{{orgObject.name}}</option>
                    </select>
                  </div>
  
                  <div class="col-3 float-left form-group p-1">
                    <select class="form-control form-control-sm input-custom" (change)="selectPeoByAllGeofence($event.target.value)">
                      <option value="">Select PEO</option>
                      <option *ngFor="let peoObject of peoDataByOrgForAllGeofence" [value]="peoObject.userId">{{peoObject.firstName + ' ' + peoObject.lastName}}</option>
                    </select>
                  </div>
                
                  <div class="form-group p-1 col-1 float-left">
                    <button class="btn btn-sm btn-success w-100" type="button" (click)="searchOrgDataAllGeofence()"><i class="fas fa-search"></i></button>
                  </div>
                </div>
             

                <div class="form-group p-1 col-2 float-right">
                  <a type="button" class="mr-3 mt-2 float-right" (click)="downloadChartImageForAll($event, selectedOrgStatsDataAllGeofence, 3, chartNameAllGeofence)">
                    <i class="fas fa-image mr-1" aria-hidden="true" matTooltip="Export Chart PNG"></i>
                  </a>
                  <a type="button" class="mr-3 mt-2 float-right" (click)="excelSheetDownloadForAll(selectedOrgStatsDataAllGeofence, chartNameAllGeofence)">
                    <i class="fa fa-file mr-1" aria-hidden="true" matTooltip="Export Shift Report"></i>
                  </a>
                </div>

              
                <div class="container-fluid">
                  <div>
                    <div style="display: block">
                      <canvas baseChart
                              [datasets]="barChartDataAllGeofence"
                              [labels]="barChartLabelsAllGeofence"
                              [options]="myoption"
                              [legend]="barChartLegend"
                              [chartType]="barChartType">
                      </canvas>
                      <!-- <canvas baseChart
                          [datasets]="barChartDataAllGeofence"
                          [labels]="barChartLabelsAllGeofence"
                          [options]="stackedBarChartOptions"
                          [legend]="barChartLegend"
                          [chartType]="barChartType">
                      </canvas> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>











            <div class="card col-6 ">
              <div class="card-header row">
                <div class="h5 mb-3 text-center col-12"> 
                  {{chartNamePeoLastShift}} 
                </div>
                
                <div class="col-10 row">
                  <div *ngIf="userRole == 'ROLE_SUPER_ADMIN'" class="col-6 form-group p-1">
                    <select class="form-control form-control-sm input-custom" (change)="selectOrgByPeoLastShift($event.target.value)">
                      <option value="" >Select Organization</option>
                      <option *ngFor="let orgObject of allOrgsData" [value]="orgObject.id">{{orgObject.name}}</option>
                    </select>
                  </div>
  
                
                  <div class="col-1 form-group p-1">
                    <button class="btn btn-sm btn-success w-100" type="button" (click)="searchOrgDataByPeoLastShift()"><i class="fas fa-search"></i></button>
                  </div>
                </div>
              

                <div class="form-group p-1 col-2 float-right">
                  <a type="button" class="mr-3 mt-2 float-right" (click)="downloadChartImageForAll($event, selectedOrgStatsDataByPeoLastShift, 4, chartNamePeoLastShift)">
                    <i class="fas fa-image mr-1" aria-hidden="true" matTooltip="Export Chart PNG"></i>
                  </a>
                  <a type="button" class="mr-3 mt-2 float-right" (click)="excelSheetDownloadForAll(selectedOrgStatsDataByPeoLastShift, chartNamePeoLastShift)">
                    <i class="fa fa-file mr-1" aria-hidden="true" matTooltip="Export Shift Report"></i>
                  </a>
                </div>

              
                <div class="container-fluid">
                  <div>
                    <div style="display: block">
                      <canvas baseChart
                              [datasets]="barChartDataByPeoLastShift"
                              [labels]="barChartLabelsByPeoLastShift"
                              [options]="myoption"
                              [legend]="barChartLegend"
                              [chartType]="barChartType">
                      </canvas>
                    </div>
                  </div>
                </div>
              </div>
            </div>








            <div class="card col-6 ">
              <div class="card-header">
                <div class="h5 mb-3 text-center"> 
                  {{chartNameMulti}} 
                </div>

                <div class="form-group p-1 col-3 float-left">
                  <!-- <label>Select Date Range</label> -->
                  <input readonly type="text" matInput placeholder="Select Date Range"
                    class="form-control form-control-sm  input-custom pl-2 mt-0"
                    ngxDaterangepickerMd
                    [locale]="{format: 'YYYY-MM-DD'}"
                    [(ngModel)]="selectedDateMulti"
                    startKey="start"
                    endKey="end"
                    [showCustomRangeLabel]="true"
                    [alwaysShowCalendars]="true"
                    [linkedCalendars]="true"
                    name="daterange"/>
                </div>
              
                <div *ngIf="userRole == 'ROLE_SUPER_ADMIN'" class="col-3 float-left form-group p-1">
                  <select class="form-control form-control-sm input-custom" (change)="selectOrgMulti($event.target.value)">
                    <option value="" >Select Organization</option>
                    <option *ngFor="let orgObject of allOrgsData" [value]="orgObject.id">{{orgObject.name}}</option>
                  </select>
                </div>

                <div class="col-3 float-left form-group p-1">
                  <select class="form-control form-control-sm input-custom" (change)="selectGeofenceMulti($event.target.value)">
                    <option value="">Select Geofence</option>
                    <option *ngFor="let geofenceObject of allGeofenceData" [value]="geofenceObject.geofenceId">{{geofenceObject.geofenceName}}</option>
                  </select>
                </div>

                <div class="col-2 float-left form-group p-1">
                  <select class="form-control form-control-sm input-custom" (change)="selectPeoMulti($event.target.value)">
                    <option value="">Select PEO</option>
                    <option *ngFor="let peoObject of peoDataByOrgForMulti" [value]="peoObject.userId">{{peoObject.firstName + ' ' + peoObject.lastName}}</option>
                  </select>
                </div>

                <div class="form-group p-1 col-1 float-left">
                  <button class="btn btn-sm btn-success w-100" type="button" (click)="searchOrgDataMulti()"><i class="fas fa-search"></i></button>
                </div>
                            


                <div class="form-group p-1 col-2 float-right">
                  <a type="button" class="mr-3 mt-2 float-right" (click)="downloadChartImageForAll($event, selectedOrgStatsDataMulti, 5, chartNameMulti)">
                    <i class="fas fa-image mr-1" aria-hidden="true" matTooltip="Export Chart PNG"></i>
                  </a>
                  <a type="button" class="mr-3 mt-2 float-right" (click)="excelSheetDownloadForAll(selectedOrgStatsDataMulti, chartNameMulti)">
                    <i class="fa fa-file mr-1" aria-hidden="true" matTooltip="Export Shift Report"></i>
                  </a>
                </div>

              
                <div class="container-fluid">
                  <div>
                    <div style="display: block">
                      <canvas  id="multiDonutChart" >{{ chartDonutMulti }}</canvas>
                    </div>
                  </div>
                </div>
              </div>
            </div>








            

            <div class="card col-6 ">
              <div class="card-header">
                <div class="h5 mb-3 text-center"> 
                  {{chartNameLpn}} 
                </div>

                <div class="form-group p-1 col-4 float-left">
                  <!-- <label>Select Date Range</label> -->
                  <input readonly type="text" matInput placeholder="Select Date Range"
                    class="form-control form-control-sm  input-custom pl-2 mt-0"
                    ngxDaterangepickerMd
                    [locale]="{format: 'YYYY-MM-DD'}"
                    [(ngModel)]="selectedDateByLpn"
                    startKey="start"
                    endKey="end"
                    [showCustomRangeLabel]="true"
                    [alwaysShowCalendars]="true"
                    [linkedCalendars]="true"
                    name="daterange"/>
                </div>
              
                <div *ngIf="userRole == 'ROLE_SUPER_ADMIN'" class="col-4 float-left form-group p-1">
                  <select class="form-control form-control-sm input-custom" (change)="selectOrgByLpn($event.target.value)">
                    <option value="" >Select Organization</option>
                    <option *ngFor="let orgObject of allOrgsData" [value]="orgObject.id">{{orgObject.name}}</option>
                  </select>
                </div>


                <div class="col-3 float-left form-group p-1">
                    <input type="text" class="form-control form-control-sm input-custom" [(ngModel)]="licensePlate" placeholder="License Plate" />
                </div>


                <div class="form-group p-1 col-1 float-left">
                  <button class="btn btn-sm btn-success w-100" type="button" (click)="searchOrgDataByLpn()"><i class="fas fa-search"></i></button>
                </div>
                            

                <div class="form-group p-1 col-2 float-right">
                  <a type="button" class="mr-3 mt-2 float-right" (click)="downloadChartImageForAll($event, selectedOrgStatsDataByLpn, 6, chartNameLpn)">
                    <i class="fas fa-image mr-1" aria-hidden="true" matTooltip="Export Chart PNG"></i>
                  </a>
                  <a type="button" class="mr-3 mt-2 float-right" (click)="excelSheetDownloadForAll(selectedOrgStatsDataByLpn, chartNameLpn)">
                    <i class="fa fa-file mr-1" aria-hidden="true" matTooltip="Export Shift Report"></i>
                  </a>
                </div>

              
                <div class="container-fluid">
                  <div>
                    <div style="display: block">
                      <canvas  id="lpnDonutChart" >{{ chartDonutLpn }}</canvas>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div>
      </div>





        <div *ngIf="userRole == 'ROLE_SUPER_ADMIN'" class="card">
          <h5 class="card-header h5">Active Laptops</h5>
          <div class="card-body row">

          </div>
        </div>
        
      </div>
    </div>


  </div>
</div>